class LoadMore {
    constructor() {
        this.loadMoreButton = document.querySelector(".load-more-button");
        // Check if loadMoreButton exists before using it
        if (this.loadMoreButton) {
            this.nextPageUrl = this.loadMoreButton.getAttribute("next-page");
            // this.loadingSVG = this.loadMoreButton.querySelector('svg');
            this.removePreviousListeners();
            this.initLoadMoreButton();
            this.loadingSVG = this.loadMoreButton.querySelector('.load-more-animate');
        } else {
            this.nextPageUrl = null;
            // this.loadingSVG = null; 
        }

        this.productGrid = document.querySelector("[data-product-grid]");
        this.productGridContainer = document.getElementById("product-grid");
        this.totalProductsCount = document.querySelector("[data-total-products-count]");
        this.loadedProductsCount = document.querySelector("[data-loaded-products-count]");
        this.progressBar = document.querySelector("[data-progress-bar]");
        this.totalResults = this.productGrid ? this.productGrid.querySelectorAll('li').length : 0;
        this.loadedResults = this.totalResults;
        this.clicked = false;

        if (this.loadMoreButton) { // Make sure loadMoreButton exists
            this.removePreviousListeners();
            this.initLoadMoreButton();
            // this.loadingSVG = this.loadMoreButton.querySelector('.load-more-animate');
        }
    }

    removePreviousListeners() {
        const newButton = this.loadMoreButton.cloneNode(true);
        this.loadMoreButton.parentNode.replaceChild(newButton, this.loadMoreButton);
        this.loadMoreButton = newButton;
    }

    initLoadMoreButton() {
        this.loadMoreButton.addEventListener("click", (event) => {
            event.preventDefault();
            if (!this.clicked) {
                // this.loadingSVG.classList.remove('hidden'); 
                this.clicked = true;
                this.getNextPageData(this.nextPageUrl);
            }
        });
    }

    getNextPageData(url) {
        fetch(url)
            .then(response => response.text())
            .then(html => {
                let parser = new DOMParser();
                let doc = parser.parseFromString(html, "text/html");
                this.injectNewProductGridItems(doc);
                this.updateButton(doc);
            })
            .catch(error => console.error("Error: ", error))
            .finally(() => {
                // this.loadingSVG.classList.add('hidden');
                this.updateProgressBar();
                window.history.pushState({}, "", url);
            });
    }

    injectNewProductGridItems(doc) {
        let newItems = doc.querySelectorAll("#product-grid>li");
        // newItems.forEach(item => {
        //     item.querySelector("img").setAttribute("loading", "eager");
        // });
        this.productGrid.append(...newItems);
        this.loadedResults += newItems.length;
        this.loadedProductsCount.textContent = this.loadedResults;
    }

    updateButton(doc) {
        this.nextPageUrl = doc.querySelector(".load-more-button").getAttribute("next-page");
        this.loadMoreButton.setAttribute("next-page", this.nextPageUrl);
        this.loadMoreButton.setAttribute("href", this.nextPageUrl);

        if (this.nextPageUrl) {
            this.clicked = false;
            this.loadMoreButton.querySelector('span').textContent = "Load More";
        } else {
            this.loadMoreButton.querySelector('span').textContent = "No more items";
            this.loadMoreButton.setAttribute('disabled', 'true');
        }
    }

    // Update the progress bar
    updateProgressBar() {
        this.totalResults = parseInt(this.totalProductsCount.textContent);
        let progress = (this.loadedResults / this.totalResults) * 100;
        this.progressBar.style.width = `${progress}%`;
        this.progressBar.setAttribute("aria-valuenow", progress);
    }


}

// Create a new instance of LoadMore
let loadMore = new LoadMore();